import { css, styled } from '../../hooks/theme';

interface MultiToggleProps {
  selected: boolean;
}

export const Container = styled.div`
  border-radius: 4px;

  display: flex;

  > * {
    &:first-child {
      border-left: 1px solid ${props => props.theme.colors.neutral.grey[40]};
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-right: 1px solid ${props => props.theme.colors.neutral.grey[40]};
      border-radius: 0 4px 4px 0;
    }
  }
`;

export const OptionButton = styled.button<MultiToggleProps>`
  padding: 8px 16px;
  height: 36px;

  background: none;
  border: none;
  border-width: 1px 0;
  border-style: solid;
  border-color: ${props => props.theme.colors.neutral.grey[40]};
  box-sizing: border-box;

  cursor: pointer;
  animation: color 0.1s;

  display: flex;
  align-items: center;

  ${props =>
    props.selected &&
    css`
      color: ${props.theme.colors.brand.primary[120]};
      border-color: ${props => props.theme.colors.brand.primary[100]} !important;
      background-color: ${props.theme.colors.brand.primary[1]};
      p {
        font-weight: 600;
      }
    `}
`;

export const OptionDivider = styled.div<MultiToggleProps>`
  height: 36px;
  border-left: 1px solid ${props => props.theme.colors.neutral.grey[40]};

  ${props =>
    props.selected &&
    css`
      border-color: ${props.theme.colors.brand.primary[100]};
    `}
`;
